import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const resetDevice = async (setLoading, setOpen, mobileNumber, callSign, type, onSuccess) => {
    if (setLoading) setLoading(true);
    const url = `${API_URL}/Device/${type === 'revoke' ? 'revoke_auth' : 'reset'}`;
    const payload = {
        call_sign: callSign,
        mobile_number: mobileNumber,
    };

    axios
        .post(url, payload)
        .then((r) => {
            engine.broadcastMessage('snackbar', {
                type: 'success',
                message: `Successfully ${
                    type === 'update_callsign'
                        ? 'updated callsign'
                        : type === 'revoke'
                        ? 'revoked authorization'
                        : 'sent MyERA link. Contact support to re-authorise Heal AI 911'
                }`,
            });
            if (setOpen) setOpen(false);
            if (onSuccess) onSuccess(r);
        })
        .catch((err) => {
            engine.broadcastMessage('snackbar', {
                type: 'error',
                message: err.response.data || 'An error has occurred',
            });
        })
        .finally(() => {
            if (setLoading) setLoading(false);
        });
};

export const derosterEmployee = async (setLoading, setOpen, employeeNumber, onSuccess) => {
    if (setLoading) setLoading(true);
    const url = `${API_URL}/Employee/deroster`;
    const payload = {
        employee_number: employeeNumber,
    };

    axios
        .post(url, payload)
        .then((r) => {
            engine.broadcastMessage('snackbar', {
                type: 'success',
                message: `Successfully derostered employee`,
            });
            if (setOpen) setOpen(false);
            if (onSuccess) onSuccess(r);
        })
        .catch((err) => {
            engine.broadcastMessage('snackbar', {
                type: 'error',
                message: err.response.data || 'An error has occurred',
            });
        })
        .finally(() => {
            if (setLoading) setLoading(false);
        });
};

export const archiveEntity = async (setLoading, setOpen, entity, identifier, onSuccess) => {
    if (setLoading) setLoading(true);

    const url = `${API_URL}/${entity}/archive`;
    const payload = {};

    if (entity === 'Employee') {
        payload.employee_number = identifier;
    } else if (entity === 'Device') {
        payload.mobile_number = identifier;
    } else if (entity === 'Vehicle') {
        payload.call_sign = identifier;
    }

    axios
        .post(url, payload)
        .then((r) => {
            engine.broadcastMessage('snackbar', {
                type: 'success',
                message: `Successfully archived ${entity}`,
            });
            if (setOpen) setOpen(false);
            if (onSuccess) onSuccess(r);
        })
        .catch((err) => {
            engine.broadcastMessage('snackbar', {
                type: 'error',
                message: err.response.data || 'An error has occurred',
            });
        })
        .finally(() => {
            if (setLoading) setLoading(false);
        });
};

export const provisionHeal911 = async (setLoading, setOpen, mobile_number, onSuccess) => {
    if (setLoading) setLoading(true);

    const url = `${API_URL}/Device/provision_heal_911`;
    const payload = {
        mobile_number: mobile_number,
    };

    axios
        .post(url, payload)
        .then((r) => {
            engine.broadcastMessage('snackbar', {
                type: 'success',
                message: `Successfully sent provisioning SMS to ${mobile_number}`,
            });
            if (setOpen) setOpen(false);
            if (onSuccess) onSuccess(r);
        })
        .catch((err) => {
            engine.broadcastMessage('snackbar', {
                type: 'error',
                message: err.response.data || 'An error has occurred',
            });
        })
        .finally(() => {
            if (setLoading) setLoading(false);
        });
};

// TODO: [JE] Add method here to reset auto-transition state of a vehicle
//            (My own idea, client has not yet requested this)
